if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      // loop through the ajax cart current items
      addCompareAtPrice(cart) {
        return new Promise((resolve) => {
          let counter = 0;
          cart.items.forEach((item, index, array) => {
            fetch(`/products/${item.handle}/.js`)
              .then((res) => {
                return res.json();
              })
              .then((product) => {
                counter++;
                product.variants.forEach((variant) => {
                  if (
                    variant.compare_at_price != null &&
                    variant.id == item.variant_id
                  )
                    item["compare_at_price"] = variant.compare_at_price;
                  else item["compare_at_price"] = 0;
                });
                if (counter === array.length) {
                  resolve(cart);
                }
              });
          });
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.setAttribute("disabled", true);
        this.submitButton.textContent = window.variantStrings.loading;

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              this.submitButton.textContent = window.variantStrings.unavailable;
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    // this.handleCartData(response);
                    this.handleCartData(response.sections, config);
                  });
                },
                {once: true},
              );
              quickAddModal.hide(true);
            } else {
              // this.cartNotification.renderContents(response);
              this.handleCartData(response.sections, config);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          });
      }

      handleCartData(sections, config) {
        // fetch the ajax cart object
        fetch(`${routes.cart_url}`, config)
          // return the data as valid JSON
          .then((response) => response.json())
          .then((response) => this.addCompareAtPrice(response))
          .then((response) => {
            this.cartNotification.renderContents(
              response.items,
              sections,
              "full-cart",
              false,
              response.total_price
            );
            this.submitButton.textContent = window.variantStrings.addToCart;
            this.submitButton.removeAttribute("disabled", true);

            // pre fil the data attribute for promo message
            let watch = document.querySelector('#deal-message-notification-sidecart') ? document.querySelector('#deal-message-notification-sidecart').dataset.dealIds : null; 


            if(watch){
              let promos = document.querySelector('#deal-message-notification-sidecart').dataset.promoIds;

              let _ids = watch.split(',');
              _ids.pop();

              let _pids = promos.split(',');
              _pids.pop();
              
              let c = 0;
  
              let cartIDS = response.items.map((i)=>{
                return {id: i.id.toString(), q: i.quantity };
              })
  
              cartIDS.map((i)=>{
                // console.log(i);
                if (_ids.includes(i.id)){
                  c+= i.q;
                }
                if(_pids.includes(i.id)){
                  document.querySelector('#deal-message-notification-sidecart').setAttribute('data-deal-ready', true);
                }
              })

              let full_cart_ids = [];

              let line_item_ids = response.items.map((i)=>{
                return i.id.toString();
              })

              // console.log(line_item_ids);

              document.querySelector('#deal-message-notification-sidecart').setAttribute('data-count', c);
              document.querySelector('#deal-message-notification-sidecart').setAttribute('data-cart-ids', line_item_ids);

            }
          })
          .catch((e) => {
            console.error(e);
          });
        return;
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.parentElement.querySelector(
            ".product-form__error-message-wrapper",
          );

        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}


